"use strict";
/**
 * AUTOGENERATED - DO NOT EDIT DIRECTLY
 *
 * Please see "scripts/generate-deployments/README.md" for how to modify
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.asAwsRegion = exports.AwsRegion = exports.asCurrencyCode = exports.CurrencyCode = exports.asMoneyFormatLocale = exports.MoneyFormatLocale = exports.asLanguage = exports.Language = exports.asLocale = exports.Locale = exports.asIsoCountryCode3 = exports.IsoCountryCode3 = exports.asIsoCountryCode2 = exports.IsoCountryCode2 = exports.asStage = exports.Stage = exports.asBrand = exports.Brand = void 0;
/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-redeclare */
/* eslint-disable @typescript-eslint/no-unused-vars */
exports.Brand = {
    BK: 'BK',
    FHS: 'FHS',
    PLK: 'PLK',
    TH: 'TH',
};
const asBrand = (str) => {
    if (Object.values(exports.Brand).includes(str.toUpperCase())) {
        return str.toUpperCase();
    }
    return;
};
exports.asBrand = asBrand;
exports.Stage = {
    None: 'none',
    Dev: 'dev',
    Staging: 'staging',
    Qa: 'qa',
    Prod: 'prod',
};
const asStage = (str) => {
    if (Object.values(exports.Stage).includes(str.toLocaleLowerCase())) {
        return str.toUpperCase();
    }
    return;
};
exports.asStage = asStage;
exports.IsoCountryCode2 = {
    AE: 'AE',
    AQ: 'AQ',
    AR: 'AR',
    AT: 'AT',
    AU: 'AU',
    BH: 'BH',
    BR: 'BR',
    CA: 'CA',
    CH: 'CH',
    CL: 'CL',
    CZ: 'CZ',
    DE: 'DE',
    DO: 'DO',
    EG: 'EG',
    ES: 'ES',
    FR: 'FR',
    GB: 'GB',
    IE: 'IE',
    IT: 'IT',
    KR: 'KR',
    KW: 'KW',
    KY: 'KY',
    MA: 'MA',
    MU: 'MU',
    MX: 'MX',
    MY: 'MY',
    NL: 'NL',
    NZ: 'NZ',
    OM: 'OM',
    PH: 'PH',
    PL: 'PL',
    PR: 'PR',
    PT: 'PT',
    QA: 'QA',
    RO: 'RO',
    SA: 'SA',
    SG: 'SG',
    TW: 'TW',
    US: 'US',
    ZA: 'ZA',
};
const asIsoCountryCode2 = (str) => {
    if (Object.values(exports.IsoCountryCode2).includes(str.toUpperCase())) {
        return str.toUpperCase();
    }
    return;
};
exports.asIsoCountryCode2 = asIsoCountryCode2;
exports.IsoCountryCode3 = {
    ARE: 'ARE',
    ARG: 'ARG',
    ATA: 'ATA',
    AUS: 'AUS',
    AUT: 'AUT',
    BHR: 'BHR',
    BRA: 'BRA',
    CAN: 'CAN',
    CHE: 'CHE',
    CHL: 'CHL',
    CYM: 'CYM',
    CZE: 'CZE',
    DEU: 'DEU',
    DOM: 'DOM',
    EGY: 'EGY',
    ESP: 'ESP',
    FRA: 'FRA',
    GBR: 'GBR',
    IRL: 'IRL',
    ITA: 'ITA',
    KOR: 'KOR',
    KWT: 'KWT',
    MAR: 'MAR',
    MEX: 'MEX',
    MUS: 'MUS',
    MYS: 'MYS',
    NLD: 'NLD',
    NZL: 'NZL',
    OMN: 'OMN',
    PHL: 'PHL',
    POL: 'POL',
    PRI: 'PRI',
    PRT: 'PRT',
    QAT: 'QAT',
    ROU: 'ROU',
    SAU: 'SAU',
    SGP: 'SGP',
    TWN: 'TWN',
    USA: 'USA',
    ZAF: 'ZAF',
};
const asIsoCountryCode3 = (str) => {
    if (Object.values(exports.IsoCountryCode3).includes(str.toUpperCase())) {
        return str.toUpperCase();
    }
    return;
};
exports.asIsoCountryCode3 = asIsoCountryCode3;
exports.Locale = {
    ar_ae: 'ar-AE',
    en_ae: 'en-AE',
    en_aq: 'en-AQ',
    es_aq: 'es-AQ',
    fr_aq: 'fr-AQ',
    de_aq: 'de-AQ',
    it_aq: 'it-AQ',
    uk_aq: 'uk-AQ',
    th_aq: 'th-AQ',
    es_ar: 'es-AR',
    en_ar: 'en-AR',
    de_at: 'de-AT',
    en_at: 'en-AT',
    en_au: 'en-AU',
    pt_br: 'pt-BR',
    en_ca: 'en-CA',
    fr_ca: 'fr-CA',
    en_ch: 'en-CH',
    de_ch: 'de-CH',
    fr_ch: 'fr-CH',
    it_ch: 'it-CH',
    es_cl: 'es-CL',
    en_cl: 'en-CL',
    cs_cz: 'cs-CZ',
    en_cz: 'en-CZ',
    de_de: 'de-DE',
    en_de: 'en-DE',
    es_do: 'es-DO',
    en_do: 'en-DO',
    ar_eg: 'ar-EG',
    en_eg: 'en-EG',
    es_es: 'es-ES',
    ca_es: 'ca-ES',
    gl_es: 'gl-ES',
    eu_es: 'eu-ES',
    en_es: 'en-ES',
    pt_es: 'pt-ES',
    en_gb: 'en-GB',
    en_ie: 'en-IE',
    en_ky: 'en-KY',
    ar_ma: 'ar-MA',
    fr_ma: 'fr-MA',
    en_mu: 'en-MU',
    es_mx: 'es-MX',
    en_mx: 'en-MX',
    ms_my: 'ms-MY',
    en_my: 'en-MY',
    nl_nl: 'nl-NL',
    en_nl: 'en-NL',
    en_nz: 'en-NZ',
    ar_om: 'ar-OM',
    en_om: 'en-OM',
    tl_ph: 'tl-PH',
    en_ph: 'en-PH',
    pl_pl: 'pl-PL',
    en_pl: 'en-PL',
    en_pr: 'en-PR',
    es_pr: 'es-PR',
    pt_pt: 'pt-PT',
    en_pt: 'en-PT',
    es_pt: 'es-PT',
    ro_ro: 'ro-RO',
    en_ro: 'en-RO',
    ar_sa: 'ar-SA',
    en_sa: 'en-SA',
    en: 'en',
    en_us: 'en-US',
    en_za: 'en-ZA',
    en_sg: 'en-SG',
    ms_sg: 'ms-SG',
    ta_sg: 'ta-SG',
    zh_sg: 'zh-SG',
    ar_bh: 'ar-BH',
    en_bh: 'en-BH',
    fr_fr: 'fr-FR',
    en_fr: 'en-FR',
    it_it: 'it-IT',
    en_it: 'en-IT',
    ko_kr: 'ko-KR',
    en_kr: 'en-KR',
    ar_kw: 'ar-KW',
    en_kw: 'en-KW',
    ar_qa: 'ar-QA',
    en_qa: 'en-QA',
    zh_tw: 'zh-TW',
    en_tw: 'en-TW',
};
const asLocale = (str) => {
    const [language, iso2] = str.replace('_', '-').split('-');
    const localeStr = (iso2
        ? `${language.toLowerCase()}-${iso2.toUpperCase()}`
        : language.toLowerCase());
    if (Object.values(exports.Locale).includes(localeStr)) {
        return localeStr;
    }
    return;
};
exports.asLocale = asLocale;
exports.Language = {
    ar: 'ar',
    ca: 'ca',
    cs: 'cs',
    de: 'de',
    en: 'en',
    es: 'es',
    eu: 'eu',
    fr: 'fr',
    gl: 'gl',
    it: 'it',
    ko: 'ko',
    ms: 'ms',
    nl: 'nl',
    pl: 'pl',
    pt: 'pt',
    ro: 'ro',
    ta: 'ta',
    th: 'th',
    tl: 'tl',
    uk: 'uk',
    zh: 'zh',
};
const asLanguage = (str) => {
    if (Object.values(exports.Language).includes(str.toLowerCase())) {
        return str.toLowerCase();
    }
    return;
};
exports.asLanguage = asLanguage;
exports.MoneyFormatLocale = {
    ar_ae: 'ar_ae',
    ar_bh: 'ar_bh',
    ar_eg: 'ar_eg',
    ar_kw: 'ar_kw',
    ar_ma: 'ar_ma',
    ar_om: 'ar_om',
    ar_qa: 'ar_qa',
    cmn: 'cmn',
    cs: 'cs',
    de: 'de',
    de_at: 'de_at',
    en_au: 'en_au',
    en_cl: 'en_cl',
    en_gb: 'en_gb',
    en_ky: 'en_ky',
    en_mu: 'en_mu',
    en_nz: 'en_nz',
    en_pr: 'en_pr',
    en_sa: 'en_sa',
    en_za: 'en_za',
    es_ar: 'es_ar',
    es_do: 'es_do',
    es_es: 'es_es',
    es_mx: 'es_mx',
    fr_ch: 'fr_ch',
    fr_fr: 'fr_fr',
    it_it: 'it_it',
    ko_kr: 'ko_kr',
    ms_my: 'ms_my',
    nl_nl: 'nl_nl',
    pl: 'pl',
    pt_br: 'pt_br',
    pt_pt: 'pt_pt',
    ro: 'ro',
    tl_ph: 'tl_ph',
    zh_tw: 'zh_tw',
};
const asMoneyFormatLocale = (str) => {
    if (Object.values(exports.MoneyFormatLocale).includes(str.toLowerCase())) {
        return str.toLowerCase();
    }
    return;
};
exports.asMoneyFormatLocale = asMoneyFormatLocale;
exports.CurrencyCode = {
    AED: 'AED',
    ARS: 'ARS',
    AUD: 'AUD',
    BHD: 'BHD',
    BRL: 'BRL',
    CAD: 'CAD',
    CHF: 'CHF',
    CLP: 'CLP',
    CZK: 'CZK',
    DOP: 'DOP',
    EGP: 'EGP',
    EUR: 'EUR',
    GBP: 'GBP',
    KRW: 'KRW',
    KWD: 'KWD',
    KYD: 'KYD',
    MAD: 'MAD',
    MUR: 'MUR',
    MXN: 'MXN',
    MYR: 'MYR',
    NZD: 'NZD',
    OMR: 'OMR',
    PHP: 'PHP',
    PLN: 'PLN',
    QAR: 'QAR',
    RON: 'RON',
    SAR: 'SAR',
    SGD: 'SGD',
    TWD: 'TWD',
    USD: 'USD',
    ZAR: 'ZAR',
};
const asCurrencyCode = (str) => {
    if (Object.values(exports.CurrencyCode).includes(str.toUpperCase())) {
        return str.toUpperCase();
    }
    return;
};
exports.asCurrencyCode = asCurrencyCode;
exports.AwsRegion = {
    EU_CENTRAL_1: 'eu-central-1',
    US_EAST_2: 'us-east-2',
    AP_SOUTHEAST_1: 'ap-southeast-1',
    US_EAST_1: 'us-east-1',
    EU_WEST_3: 'eu-west-3',
};
const asAwsRegion = (str) => {
    if (Object.values(exports.AwsRegion).includes(str.toLowerCase())) {
        return str.toLowerCase();
    }
    return;
};
exports.asAwsRegion = asAwsRegion;
